import Registration from "../../components/Login/LandLodRegistration";

const SignUp = () => {
  return (
    <div className="w-full h-screen mt-[80px] mb-8" >
      <Registration/>
    </div>
  );
};

export default SignUp;
